import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCdTfw2Rv6H_fFhGrMGZMxTqZ8gYCju4uY",
  authDomain: "p1firebase-c82ad.firebaseapp.com",
  projectId: "p1firebase-c82ad",
  storageBucket: "p1firebase-c82ad.firebasestorage.app",
  messagingSenderId: "1028926653032",
  appId: "1:1028926653032:web:91faa8c0959d05e923b1dd",
  measurementId: "G-2FJ24YYDXR"
};

const vapidKey = "BO2KTHkdjCGK_uthWPB9LzvCB4EUWcKpS9gHYAHlT9pgk4WR1caZjsrUofP6_vGSQ52yIDw-ODBRbzzUMAseEKk";  

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
const messaging = getMessaging(app);

export const requestFCMToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      throw new Error("Notification permission not granted");
    }

    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    // Make sure the service worker is ready before proceeding
    const serviceWorkerReady = await navigator.serviceWorker.ready;

    const token = await getToken(getMessaging(), {
      vapidKey,
      serviceWorkerRegistration: serviceWorkerReady,
    });

    return token;
  } catch (err) {
    console.error("Error getting FCM token", err);
    throw err;
  }
};
